import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["sizeSelect", "quantitySelect"]
  static values = { max: Number, available: Number }

  connect() {
    console.log('StockQuantitySelector connected');
    this.updateQuantityOptions()
  }

  updateQuantityOptions() {
    const sizeSelected = this.hasSizeSelectTarget ? this.sizeSelectTarget.value : null
    if (this.hasSizeSelectTarget && !sizeSelected) {
      this.renderPlaceholder("Select size")
      return
    }

    const available = this.resolveAvailable()
    if (!available || available <= 0) {
      this.renderPlaceholder("Out of stock")
      return
    }

    const max = Math.min(this.maxValue || 10, available)
    this.quantitySelectTarget.disabled = false
    this.quantitySelectTarget.innerHTML = ""
    for (let qty = 1; qty <= max; qty += 1) {
      const option = document.createElement("option")
      option.value = qty
      option.textContent = qty
      this.quantitySelectTarget.appendChild(option)
    }
  }

  resolveAvailable() {
    if (this.hasSizeSelectTarget) {
      const selected = this.sizeSelectTarget.selectedOptions[0]
      if (!selected) return 0
      return parseInt(selected.dataset.available || "0", 10)
    }

    return this.availableValue || 0
  }

  renderPlaceholder(label) {
    this.quantitySelectTarget.disabled = true
    this.quantitySelectTarget.innerHTML = ""
    const option = document.createElement("option")
    option.value = ""
    option.textContent = label
    this.quantitySelectTarget.appendChild(option)
  }
}
